<div #kanbanNoSwimlane>
  <!-- Column-Headings -->
  <div *ngIf="this.data.boardConfiguration" class="column-headers">
    <div *ngFor="let column of this.data.boardConfiguration.columns"
         class="kanban-column board-column--headers">

      <div class="column-name">{{column.name}}</div>

      <div class="wip-limit"
           [ngClass]="{ 'wip-limit': true,
                          'exceeded': column.current > column.max,
                          'no-limit': !column.max} ">
        {{column.current}} /
        <span *ngIf="column.max; else inifiteIssues">{{column.max}}</span>
        <ng-template #inifiteIssues>∞</ng-template>
      </div>
    </div>
  </div>

  <!-- Tasks rows -->
  <div class="expedite-lane userstory-row" *ngIf="data.expediteLane" [ngClass]="{ 'open': this.data.expediteLane }">
    <div *ngFor="let column of taskboardData;" cdkDropList class="kanban-column issue-list board-column"
         id="addToExpediteLane-{{column.id}}"
         [cdkDropListConnectedTo]="['addToBoard-'+column.id,  'productbacklog']"
         [cdkDropListData]="column"
         (cdkDropListDropped)="onIssueDropped($event, true)"
         [ngClass]="{'empty-column' : (column.isEmpty)}"
         [attr.data-columnname]="column.name"
         [attr.data-columnid]="column.id"
         [attr.data-columntype]="column.type"
    >

      <ng-container *ngFor="let task of column.tasks">
        <app-kanban-taskcard *ngIf="data.expediteLane && task.isExpedited"
          [task]="task" class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone stickerdropzone" cdkDrag
                             (cdkDragReleased)="onCardReleased($event)"
                             (cdkDragMoved)="onCardMoved($event)"
                             (dblclick)="this.onIssueDoubleClicked($event, task)"
                             [cdkDragData]="task"
                             [attr.data-taskcardid]="task.id"
                             [ngClass]="{'parent-issue': (!task.isSubissue),'sub-issue':(task.isSubissue)}"
                             [kanbanBoardViewComponent]="this.data.parent">
          <div *cdkDragPreview class="custom-drag-preview">
            <div class="issue-list-element">{{task.summary}}</div>
          </div>
        </app-kanban-taskcard>
      </ng-container>
    </div>
  </div>

  <div [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}" class="userstory-row" cdkDropListGroup>
    <!-- Column for every Column in BoardConfiguration -->
    <div *ngFor="let column of taskboardData;" cdkDropList class="kanban-column issue-list board-column"
         id="addToBoard-{{column.id}}"
         [cdkDropListData]="column"
         [cdkDropListConnectedTo]="['addToExpediteLane-'+column.id,  'productbacklog']"
         (cdkDropListDropped)="onIssueDropped($event, false)"
         [ngClass]="{'empty-column' : (column.isEmpty)}"
         [attr.data-columnname]="column.name"
         [attr.data-columnid]="column.id"
         [attr.data-columntype]="column.type"
    >

    <ng-container *ngFor="let task of column.tasks">
      <app-kanban-taskcard *ngIf="!data.expediteLane || !task.isExpedited"
                           [task]="task" class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone stickerdropzone" cdkDrag
                           (cdkDragReleased)="onCardReleased($event)"
                           (cdkDragMoved)="onCardMoved($event)"
                           (dblclick)="this.onIssueDoubleClicked($event, task)"
                           [cdkDragData]="task"
                           [attr.data-taskcardid]="task.id"
                           [ngClass]="{'parent-issue': (!task.isSubissue),'sub-issue':(task.isSubissue)}"
                           [kanbanBoardViewComponent]="this.data.parent">
        <div *cdkDragPreview class="custom-drag-preview">
          <div class="issue-list-element">{{task.summary}}</div>
        </div>
      </app-kanban-taskcard>
    </ng-container>
    </div>
  </div>
</div>
